import { ContextualContentBox } from "@foodpilot/foods";
import { Box } from "@mui/material";

type ActionDescriptionProps = {
    label: string | undefined;
};
export const ActionDescription = (props: ActionDescriptionProps) => {
    const { label } = props;

    if (label === undefined || label === "") return null;

    return (
        <ContextualContentBox>
            <Box dangerouslySetInnerHTML={{ __html: label }} />
        </ContextualContentBox>
    );
};
